import { useContext } from 'react';

import { Button } from '@/components/Button/Button';
// Components
import { Context } from '@/components/Store';
import { ActionTypes } from '@/components/Store.d';
// Modules
import { setInnerHTML } from '@/lib/util';

const Alert = () => {
  const [ state, dispatch ] = useContext(Context);

  const handleClose = () => {
    dispatch({
      type: ActionTypes.hideError
    });
  };

  const replaceTemplateExpression = (message: string) => {
    if (message.includes('{{userEmail}}')) {
      return message.replace('{{userEmail}}', state.user.email || '');
    }

    return message;
  };

  return (
    <div
      className="alert dialog dialog-width345"
      hidden={state.hideAlert}
      role="alert"
    >
      <section
        aria-labelledby="dialog-discard-title"
        aria-modal="true"
        className="dialog--surface"
        role="dialog"
      >
        {state?.alertTitle ? (
          <h1
            className="dialog--title"
            id="dialog-discard-title"
          >
            {state.alertTitle}
          </h1>
        ) : null}
        {state?.alertMessage ? <p dangerouslySetInnerHTML={setInnerHTML(replaceTemplateExpression(state.alertMessage))}></p> : null}

        <div className="dialog--actions">
          <Button
            ariaLabel="Schließen"
            className="form--button form--button-secondary form--button-small"
            onClick={handleClose}
            type="button"
          >
            Okay
          </Button>
        </div>
      </section>
      <div className="dialog--backdrop"></div>
    </div>
  );
};

export { Alert };
